import CardSystem from '../CardSystem';
import CardAnimationTask from '../../../Utility/Task/CardAnimationTask';
import { UIEvent } from '../../UI/BaseUISystem';
import { ICardStateTaskData } from '../../../State/Card/ICardState';
import BaseCard from '../../../Prototype/Level/Card/BaseCard';
import Game from '../../../Game';
import { CardActions } from '../../../State/Card/CardActions';
import RockCard from '../../../Prototype/Level/Card/RockCard';
import { Anim } from '../../Animation/AnimationHelper';

export default function RockCardAnimation(
    system: CardSystem,
    taskData: ICardStateTaskData
): void {
    system.scene.emit(UIEvent.DISABLE_INTERACTIVITY);
    // PlaySound('stone');
    const sourceCard = system.getCardByID(taskData.cards[0]) as RockCard;
    sourceCard.updatePickaxesAmountText(0);
    Anim(sourceCard.getPickaxesAmountText(), { alpha: 0, duration: 300 });

    const targetCards: BaseCard[] = [];
    for (let i = 0; i < taskData.cards.length; i++) {
        const card: BaseCard = system.getCardByID(taskData.cards[i]);
        if (i < taskData.cardsScore.length) {
            card.score = taskData.cardsScore[i];
        }
        targetCards.push(card);
    }
    system.taskQueue.queue(
        new CardAnimationTask(
            taskData,
            system,
            'CardRock',
            sourceCard,
            {
                system: system,
                sourceCard: sourceCard,
                targetCards: targetCards,
            },
            undefined,
            {
                onComplete: () => {
                    system?.scene?.emit(UIEvent.RESTORE_INTERACTIVITY);
                    CardActions.discardCards(
                        targetCards.map(card => card.id)
                    );
                },
            }
        )
    );
}
